import { Stack, Typography } from "@mui/material";
import { IIcon } from "../../images/IIcon";
import { useDiscardAccountMutation } from "../../../api";
import { toast } from "react-toastify";
import { CustomToast } from "../CustomToast";
import { ReuseModal } from "../ReuseModal";

export const DiscardAccountModal = ({
  campaign_id,
  account_id,
  companyName,
  onClose,
  onSuccessHandler,
}: {
  campaign_id: string;
  account_id: string;
  companyName: string;
  onClose: () => void;
  onSuccessHandler: () => void;
}) => {
  const [discardAccount, { isLoading }] = useDiscardAccountMutation();

  const discardHandler = () => {
    discardAccount({ campaign_id, account_id })
      .unwrap()
      .then(onSuccessHandler)
      .catch(() =>
        toast.error(
          <CustomToast
            type={"error"}
            text={`Something went wrong during the discard of ${companyName}. Please try again`}
            title={"Discard failed"}
          />,
        ),
      );
  };

  return (
    <ReuseModal
      isOpen={true}
      onClose={onClose}
      title={"Discard account"}
      submitBtnColor={"#CF3E00"}
      onSubmit={discardHandler}
      maxWidth={"460px"}
      isLoading={isLoading}
      isDisabledCancelBtn={isLoading}
      isDisabled={isLoading}
    >
      <Stack gap="16px">
        <Typography component="span" variant="body1" color="text.secondary">
          Are you sure you want to clear data about “{companyName}”?
        </Typography>
        <Stack direction="row" gap="8px">
          <IIcon />
          <Typography
            component="span"
            variant="body2"
            color="custom.textDarkBlue"
          >
            This will discard the company from the analysis but won't influence
            your original data source
          </Typography>
        </Stack>
      </Stack>
    </ReuseModal>
  );
};
